import httpClient from "./httpClient";

class MessagesService {
  async getMessages(liveId, limit = 5) {
    let dataReturned = await httpClient.get(
      `/messages/${liveId}?moderated=S&limit=${limit}`
    );
    return dataReturned;
  }
  async saveMessage(comment) {
    let dataReturned = await httpClient.post(`/messages`, comment);
    return dataReturned;
  }

  async createToken(liveId, data) {
    let dataReturned = await httpClient.post(`/chat/${liveId}`, data);
    return dataReturned;
  }
}

export default MessagesService;
